import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PageHeader } from './PageHeader';
import { RelatedActions } from './RelatedActions';
import { GrafanaDashboard } from './GrafanaDashboard';
import { getServiceConfig } from '../../../../services/serviceConfig';
import { DashboardSidebar } from '../DashboardSidebar/DashboardSidebar';
import styles from './ServiceDetailPage.module.css';

export const ServiceDetailPage = () => {
  const { serviceKey } = useParams();
  const navigate = useNavigate();
  const serviceConfig = getServiceConfig(serviceKey);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  if (!serviceConfig) {
    return (
      <div className={styles.errorContainer}>
        <h2>Service Not Found</h2>
        <button onClick={() => navigate('/dashboard')} className={styles.backButton}>
          Back to Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.headerWrapper}>
        <PageHeader
          title={serviceConfig.name}
          breadcrumb={`Home > ${serviceConfig.name}`}
          onBackToHome={() => navigate('/dashboard')}
          onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
        />
      </div>

      <div className={styles.mainWrapper}>
        <DashboardSidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <div className={styles.container}>
          <button className={`${styles.backButton} g-backbutton`}
            onClick={() => navigate(-1)}
          >Go Back
          </button>

          <div className={styles.content}>
            <div className={styles.serviceHeader}>
              <h1 className={styles.serviceName}>{serviceConfig.name}</h1>
            </div>

            <RelatedActions actions={serviceConfig.relatedActions} />

            <GrafanaDashboard
              dashboardConfig={serviceConfig.grafanaDashboard}
              serviceKey={serviceKey}
            />
          </div>
        </div>
      </div>
    </div>
  );
};